module.exports = __webpack_public_path__ + "img/file-----------1x-png@1x.1b2b0966.png";